import React from 'react';
import PropTypes from 'prop-types';

const CarouselTopBar = ({
  isMaximized,
  onClosed,
  onMaximize,
  onMinimize,
}) => (
  <div className="gallery-buttons">
    {/* <div className="gallery-title"><span>Render fachada principal</span></div> */}
    <button
      type="button"
      className="maximize-button"
      aria-label="Maximize"
      onClick={isMaximized ? onMinimize : onMaximize}
    >
      <span className={`icon ${isMaximized ? 'icon-frame-contract' : 'icon-frame-expand'}`} />
    </button>
    <button type="button" className="close-button" aria-label="Close" onClick={onClosed}>
      <span className="icon icon-cross" />
    </button>
  </div>
);

CarouselTopBar.propTypes = {
  isMaximized: PropTypes.bool.isRequired,
  onClosed: PropTypes.func.isRequired,
  onMaximize: PropTypes.func.isRequired,
  onMinimize: PropTypes.func.isRequired,
};
export default CarouselTopBar;
